export const emojiToPngUrl = (emoji: string): string => {
    // Convert each character in the emoji string to its Unicode code point
    const [unicode] = Array.from(emoji).map((char) => char.codePointAt(0)!.toString(16).padStart(4, '0'));

    return `https://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/72x72/${unicode}.png`;
};

export const escapeOnlyEmojis = (text: string): string => {
    // Match emoji pictographs and related sequence characters (VS16, ZWJ).
    // The `+` groups contiguous emoji code points and sequence characters
    // into a single match so that full emoji sequences are escaped together.
    const emojiRegex = /[\p{Extended_Pictographic}\uFE0F\u200D]+/gu;
    return text.replace(emojiRegex, (match) => {
        // Escape every UTF-16 code unit in the matched emoji substring.
        let escaped = '';
        for (let i = 0; i < match.length; i += 1) {
            const code = match.charCodeAt(i);
            escaped += `\\u${code.toString(16).toUpperCase().padStart(4, '0')}`;
        }
        return escaped;
    });
};
